import { createAction, props } from '@ngrx/store';

export const setAuthEmail = createAction('[Auth] Set Email', props<{ email: string }>());

export const clearAuthState = createAction('[Auth] Clear Auth State');
